/**
 * MaintenancePanel — single-screen message, no donor data. Used when the
 * admin forces maintenance mode or the device is in a service window.
 *
 * Spec: signage-device-app-spec §3.5
 */

import { applyBranding, extractBranding } from './branding.js';

export function renderMaintenance(
  root: HTMLElement,
  config: Record<string, unknown> | null
): void {
  const branding = extractBranding(config);
  applyBranding(root, branding);

  root.innerHTML = '';
  root.className = 'ag-app ag-maintenance';

  const icon = document.createElement('div');
  icon.className = 'ag-maintenance__icon';
  icon.textContent = '🛠';
  root.appendChild(icon);

  const title = document.createElement('h1');
  title.className = 'ag-maintenance__title';
  title.textContent = 'Display paused';
  root.appendChild(title);

  const sub = document.createElement('p');
  sub.className = 'ag-maintenance__sub';
  sub.textContent = 'This display is temporarily offline. It will resume automatically.';
  root.appendChild(sub);
}
